
export enum OrderLockStatusType {
  LOCKED = 'locked-active',
  UNLOCKED = 'unlocked'
};
